<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      content-class="crud-dialog"
      persistent
      max-width="400px"
    >
      <!-- <template #activator="{ on }">
        <v-btn
        v-if="$vuetify.breakpoint.mdAndUp"
          rounded
          depressed
          outlined
          color="primary"
          class="signup-btn"
          v-on="on"
          >Request Adviser Access</v-btn
        >
      </template> -->

      <v-card class="crud-card">
        <v-card-title class="crud-card-title">
          <v-row no-gutters>
            <v-col cols="11">
              <h2 class="text-h5">Request adviser access</h2>
            </v-col>
            <v-col cols="1">
              <v-icon
                class="modal-close"
                color="black"
                @click.stop="closeDialog"
                >{{ icons.mdiClose }}</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider />

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="first_name"
              v-slot="{ errors }"
              name="first_name"
              rules="required"
            >
              <v-text-field
                v-model.trim="first_name"
                label="First Name"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="last_name"
              v-slot="{ errors }"
              name="last_name"
              rules="required"
            >
              <v-text-field
                v-model.trim="last_name"
                label="Last Name"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="email_address"
              v-slot="{ errors }"
              name="email_address"
              rules="required|email"
            >
              <v-text-field
                v-model.trim="email_address"
                label="Email Address"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="cell_number"
              v-slot="{ errors }"
              name="cell_number"
              rules="required|phone"
            >
              <v-text-field
                v-model.trim="cell_number"
                label="Cell Number"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-text class="crud-card-text">
          <ValidationObserver ref="observer">
            <ValidationProvider
              id="staff_code"
              v-slot="{ errors }"
              name="staff_code"
              rules="required"
            >
              <v-text-field
                v-model.trim="staff_code"
                label="Staff Code"
                :error-messages="errors"
              />
            </ValidationProvider>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="crud-card-actions">
          <v-btn
            rounded
            depressed
            :loading="buttonLoading"
            color="primary"
            class="ml-4 mb-1"
            @click="save()"
            ><span>Submit</span
            ><v-icon small>{{ icons.mdiArrowRight }}</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorSnackbar v-model="showError" :error="errorMessage" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </div>
</template>

<script>
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { ADVISOR_REQUEST_MUTATION } from '../../constants/graphql/advisors';

  export default {
    name: 'RequestAdivsorAccess',
    components: {
      ErrorSnackbar,
      SuccessSnackbar,
    },
    mixins: [formHelperMixin],
    data(props) {
      return {
        first_name: '',
        last_name: '',
        email_address: '',
        cell_number: '',
        staff_code: '',
        dialog: props.dialogOpen,
        errorMessage: null,
        showSuccess: false,
        successMessage: null,
      };
    },
    props: {
      dialogOpen: true,
    },
    watch: {
      dialog(newValue) {
        if (newValue == true) {
          this.errorMessage = null;
        }
      },
      dialogOpen(newVal, oldVal) {
        this.dialog = newVal;
      },
    },
    methods: {
      save() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.submitAdvisorRequest();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      submitAdvisorRequest() {
        this.$apollo
          .mutate({
            mutation: ADVISOR_REQUEST_MUTATION,
            variables: {
              firstName: this.first_name,
              lastName: this.last_name,
              emailAddress: this.email_address,
              cellNumber: this.cell_number,
              staffCode: this.staff_code,
            },
          })
          .then(_response => {
            this.showSuccessMessage();
          })
          .catch(error => {
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
              this.displayErrorAndCloseDialog();
            } else {
              this.displayErrorAndCloseDialog();
              throw error;
            }
          });
      },
      showSuccessMessage() {
        this.successMessage = 'Thank you for submitting your request';
        this.showSuccess = true;
        this.closeDialog();
      },
      closeDialog() {
        this.$emit('closedDialog');
        this.dialog = false;
        this.buttonLoading = false;
        this.$refs.observer.reset();
      },
    },
  };
</script>
